import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IoniconsOutline, ND } from '@pt/pt-models';

@Component({
  selector: 'pt-extraction-card',
  template: `
    <div
      class="card dashboard-card"
      [ngClass]="{ clickCable: item.enabled }"
      (click)="clickAction.emit(true)"
    >
      <div class="card-body">
        <!-- ICONA SINISTRA -->
        <div class="card-icon">
          <pt-icon [key]="IconArrowRight" [size]="arrowSize"></pt-icon>
        </div>

        <!-- CONTENUTO -->
        <div class="card-content">
          <div class="card-title">
            <span
              class="title-text text-ellipsis"
              container="body"
              [ngbTooltip]="item.name"
            >
              {{ item.name }}
            </span>

            <!-- IMMAGINI SEMPRE A DESTRA -->
            <div class="card-images">
              <img
                *ngFor="let img of item.images"
                [width]="iconSize"
                [src]="img"
                alt="Doc Type"
              />
            </div>
          </div>

          <div class="card-subtitle text-ellipsis">
            {{ item.description }}
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .dashboard-card {
        width: 100%;
        background-color: white;
        color: var(--ptAppColor);
        border-color: color-mix(in oklab, currentColor, transparent 92%);
      }

      .dashboard-card:hover {
        border-color: color-mix(in oklab, currentColor, transparent 95%);
        background-color: color-mix(in oklab, currentColor, transparent 85%);
      }

      .clickCable {
        cursor: pointer;
      }

      .card-body {
        display: flex;
        gap: 10px;
        align-items: center;
        padding: 19px 10px;
      }

      /* ICONA SINISTRA CON SPAZIO FISSO */
      .card-icon {
        width: 48px;
        min-width: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.3;
      }

      /* CONTENUTO */
      .card-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 6px;
        width: 100%;
        overflow: hidden;
      }

      .card-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 22px;
        width: 100%;
        margin-bottom: 0;
      }

      /* TESTO TITLO CON ELLIPSIS REALE */
      .title-text {
        flex: 1;
        min-width: 0;
      }

      .card-images {
        display: flex;
        gap: 4px;
        flex-shrink: 0;
      }

      .card-subtitle {
        font-size: 15px;
      }

      /* ELLIPSIS */
      .text-ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    `,
  ],
})
export class ExtractionCardComponent {
  @Input() item: ExtractionCard;
  iconSize = 22;
  arrowSize = 70;
  @Output() clickAction: EventEmitter<boolean> = new EventEmitter<boolean>();

  ND = ND;
  public IconArrowRight = IoniconsOutline.download;
}

export interface ExtractionCard {
  ref: string;
  name: string;
  description?: string;
  images: string[];
  enabled: boolean;
}
